'use client';

import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { Text } from "../../../atoms/Text/Text.js";
import { useId } from "../../../utils/hooks/useId.js";
import { focusMockLabel } from "../InlineNotification.data.js";
function FocusMockOnHide({
  children,
  isHidden
}) {
  const id = useId();
  const focusMockRef = useRef(null);
  useEffect(() => {
    if (isHidden) focusMockRef.current?.focus();
  }, [isHidden]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Text,
      {
        "aria-hidden": "true",
        "aria-labelledby": id,
        ref: focusMockRef,
        role: "group",
        tabIndex: -1,
        visuallyHidden: true,
        children: /* @__PURE__ */ jsx(Text, { id, visuallyHidden: true, children: focusMockLabel })
      }
    ),
    !isHidden && children
  ] });
}
export {
  FocusMockOnHide
};
